import styled from 'styled-components';

export const DropDownWrapper = styled.section`
  position: relative;
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
  width: 340px;
`;
